// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__2uJ70","description":"MealItem_description__2YINS","image":"MealItem_image__dqeUA","price":"MealItem_price__3sNYl"};